export default class InvalidTwoFactorStatusError extends Error {}
